import React, { Component } from 'react';

export default class SpotifyFollowButton extends Component {
  render() {
    return (
      <div className="SpotifyFollowButton">
        <iframe 
          className="lozad"
          src="https://open.spotify.com/follow/1/?uri=spotify:artist:24r28WlEze44ZfRyJCTykU?si=86UqExwIQKG935d90TLkNw&size=detail&theme=light" 
          width="210" 
          height="56" 
          scrolling="no" 
          frameBorder="0" 
          allowtransparency="true"
        ></iframe>
      </div>    
    )
  }
}

          // style="border:none; overflow:hidden;" 



// WEBPACK FOOTER //
// ./src/components/Media/SpotifyFollowButton/SpotifyFollowButton.js